var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  보고서 양식이 없습니다.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }